<template>
  <div class="sidebar-box mt-6 p-1">
    <h6 class="mb-3 p-2 cursor-pointer" data-toggle="collapse" data-target="#feature-filter">
      {{ $t('filter.feature.title') }}
      <i class="bi bi-arrow-down-circle"></i>
    </h6>

    <div class="filter-feature-1-selected-items-filter">
      <span v-for="(item,index) in selectedFeature"
            @click="removeFeatureFromFilter(index)"
            class="filter-feature-1-selected-items-filter-item badge badge-primary rounded-pill mx-1 cursor-pointer">
        {{ item.value }}
        <i class="bi bi-x-circle-fill"/>
      </span>
    </div>

    <div id="feature-filter" :class="{'show':collapseOpen}" class="collapse p-2">
      <template v-for="feature in featuresObject">

        <div class="my-2" v-if="feature.feature_attributes.length > 0">
          <label class="cursor-pointer" data-toggle="collapse" :data-target="`#feature-filter-${feature.id}`"
                 data-v-68ac1b1a="">{{ feature.name }}</label>
          <i class="bi bi-chevron-left mr-1 text-dark" data-toggle="collapse"
             :data-target="`#feature-filter-${feature.id}`"></i>
        </div>


        <div class="collapse feature-height mr-2" :id="`feature-filter-${feature.id}`">
          <div class="form-group form-check" v-for="featureAttribute in feature.feature_attributes">
            <input v-model="selectedFeature" :value="featureAttribute" name="filter_features"
                   type="checkbox"
                   class="form-check-input" :id="`feature_filter_${featureAttribute.id}`">
            <label class="form-check-label mr-3" :for="`feature_filter_${featureAttribute.id}`">
              {{ featureAttribute.value }}
            </label>
          </div>
        </div>

      </template>

    </div>


  </div>
</template>

<script>
export default {
  name: "FilterFeature1",
  props: {
    featureColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id'].includes(value)
      }
    },
    collapseOpen: {
      type: Boolean,
      default: false
    },
    featuresObject: {
      default: []
    },
    dirtyRoute: {
      default: false
    }
  },
  data() {
    return {
      selectedFeature: [],
    }
  },
  methods: {
    getFeatureIds() {
      const ids = this.selectedFeature.map(item => {
        return item.id
      });
      return ids.length > 0 ? ids : null
    },
    filterOutput() {
      if (this.featureColumn === 'id') {
        return this.getFeatureIds();
      }
    },
    setFeaturesFromQuery() {
      let queryFeatures = this.$route.query.features

      if (queryFeatures != null) {
        queryFeatures = queryFeatures.split(',')

        // find selected features

        this.featuresObject.forEach(feature => {

          let featureAttributes = feature.feature_attributes

          if (featureAttributes.length > 0) {

            featureAttributes.forEach(featureAttribute => {

              if (queryFeatures.indexOf(featureAttribute.id.toString()) > -1) {
                this.selectedFeature.push(featureAttribute)
              }

            })


          }

        })


      }

    },
    routeQueryManager() {
      if (!this.dirtyRoute) { // stop function to work if dirtyRoute false
        return true
      }

      let features = {features: this.selectedFeature.map(item => item.id).join(',')};

      const newQuery = {
        ...this.$route.query,
        ...features
      }

      this.$router.push({query: newQuery});


    },
    removeFeatureFromFilter(featureIndex) {
      const updatedFeatures = [...this.selectedFeature];
      updatedFeatures.splice(featureIndex, 1);
      this.selectedFeature = updatedFeatures;
    }
  },
  async mounted() {
  },
  watch: {
    selectedFeature: {
      handler() {
        this.routeQueryManager()
        this.$emit('featuresObject', this.selectedFeature)
        this.$emit('features', this.filterOutput())
      }
    },
    featuresObject: {
      handler() {
        this.setFeaturesFromQuery()
      }
    },
  }
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.feature-height {
  max-height: 360px;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}
</style>